import request from '@/utils/request'


// 查询设备类型列表
export function listType(query) {
  return request({
    url: '/mibo/device-type/list',
    method: 'get',
    params: query
  })
}

// 查询设备类型分页
export function pageType(query) {
  return request({
    url: '/mibo/device-type/page',
    method: 'get',
    params: query
  })
}

// 查询设备类型详细
export function getType(data) {
  return request({
    url: '/mibo/device-type/detail',
    method: 'get',
    params: data
  })
}

// 新增设备类型
export function addType(data) {
  return request({
    url: '/mibo/device-type/add',
    method: 'post',
    data: data
  })
}

// 修改设备类型
export function updateType(data) {
  return request({
    url: '/mibo/device-type/edit',
    method: 'post',
    data: data
  })
}

// 删除设备类型
export function delType(data) {
  return request({
    url: '/mibo/device-type/delete',
    method: 'post',
    data: data
  })
}
